import {ColDef} from "ag-grid-community";
import {TemplateRef} from "@angular/core";
import {CustomRendererComponent} from "../../../ag-grid";
import {ListGroupAndUserResponse} from "it/primatoo/openapi/api/org/schemas/capability/ListGroupAndUserResponse";
import {GetTreatPermissionResponse} from "it/primatoo/openapi/api/org/schemas/treatmentdoc/GetTreatPermissionResponse";
import {
  GetCovidAsPermissionResponse
} from "it/primatoo/openapi/api/org/schemas/covidassessmentdoc/GetCovidAsPermissionResponse";

import {
  UserPermission as CovidUserPermission
} from "it/primatoo/openapi/api/org/schemas/covidassessmentdoc/getcovidaspermissionresponse/UserPermission";
import {
  GetAppAsPermissionResponse
} from "it/primatoo/openapi/api/org/schemas/appassessmentdoc/GetAppAsPermissionResponse";
import {GetAiAsPermissionResponse} from "it/primatoo/openapi/api/org/schemas/aiassessmentdoc/GetAiAsPermissionResponse";
import {
  GetDataBreachPermissionResponse
} from "it/primatoo/openapi/api/org/schemas/databreachprocess/GetDataBreachPermissionResponse";
import {
  GetGlobalMeasCheckPermissionResponse
} from "it/primatoo/openapi/api/org/schemas/globalmeasurecheckdoc/GetGlobalMeasCheckPermissionResponse";
import { DocumentPermissionData } from './document-permission-data';

export class DocumentPermissionDataUtils {

  public static fromFindAllGroupAndUserResponse(input: ListGroupAndUserResponse, ownerId: number): DocumentPermissionData[] {
    const response: DocumentPermissionData[] = [];
    input.users.forEach(u => {

      const item: DocumentPermissionData = {
        id: u.id,
        type: "USER",
        name: u.fullName,
        actions: [],
        admin: u.admin,
        owner: !!ownerId && u.id === ownerId,
      }
      response.push(item)
    })

    input.userGroups.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "GROUP",
        name: u.name,
        admin: false,
        owner: false,
        actions: []
      }
      response.push(item)
    })
    return response;
  }

  public static getColLockedDef(nameTemplateRef: TemplateRef<unknown>,
                                headerName: string): ColDef[] {
    const colDef: ColDef[] = [
      {
        field: "name",
        headerName: headerName,
        hide: false,
        editable: false,
        suppressMenu: true,
        suppressNavigable: true,
        flex: 1,
        resizable: true,
        floatingFilter: false,
        sortable: true,
        lockVisible: true,
        minWidth: 120,
        cellClass: 'no-border',
        cellRenderer: CustomRendererComponent,
        cellRendererParams: {
          ngTemplate: nameTemplateRef
        }
      },
    ]
    return colDef;
  }


  public static getColDef(nameTemplateRef: TemplateRef<unknown>,
                          actionTemplateRef: TemplateRef<unknown>,
                          accessTemplateRef: TemplateRef<unknown>,
                          deleteTemplateRef: TemplateRef<unknown>,
                          headerName: string,
                          headerAccess: string,
                          headerAction: string): ColDef[] {
    const colDef: ColDef[] = [
      {
        field: "name",
        headerName: headerName,
        hide: false,
        editable: false,
        suppressMenu: true,
        suppressNavigable: true,
        flex: 1,
        resizable: true,
        floatingFilter: false,
        sortable: true,
        lockVisible: true,
        minWidth: 130,
        cellClass: 'no-border',
        cellRenderer: CustomRendererComponent,
        cellRendererParams: {
          ngTemplate: nameTemplateRef
        }
      },
      {
        field: "access",
        headerName: headerAccess,
        hide: false,
        editable: false,
        flex: 1,
        suppressMenu: true,
        minWidth: 238,
        suppressNavigable: true,
        resizable: true,
        floatingFilter: false,
        sortable: false,
        lockVisible: true,
        cellClass: 'no-border',
        cellRenderer: CustomRendererComponent,
        cellRendererParams: {
          ngTemplate: accessTemplateRef
        }
      },
      {
        field: "actions",
        headerName: headerAction,
        hide: false,
        editable: false,
        flex: 1,
        suppressMenu: true,
        suppressNavigable: true,
        minWidth: 300,
        resizable: true,
        floatingFilter: false,
        sortable: false,
        lockVisible: true,
        wrapText: true,
        autoHeight: true,
        cellClass: 'no-border',
        cellRenderer: CustomRendererComponent,
        cellRendererParams: {
          ngTemplate: actionTemplateRef
        }
      }, {
        headerName: '',
        flex: 1,
        suppressMenu: true,
        width: 70,
        minWidth: 70,
        maxWidth: 70,
        suppressNavigable: true,
        lockVisible: true,
        editable: false,
        cellClass: 'no-border',
        cellRenderer: CustomRendererComponent,
        cellRendererParams: {
          ngTemplate: deleteTemplateRef
        }
      }]
    return colDef;
  }


  public static fromFindTreatmentPermissionsResponse(input: GetTreatPermissionResponse): DocumentPermissionData[] {
    const response: DocumentPermissionData[] = [];
    input.users.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "USER",
        name: u.fullName,
        access: u.access,
        actions: u.actions || [],
        admin: false,
        owner: false,
      }
      response.push(item)
    })

    input.userGroups.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "GROUP",
        name: u.name,
        access: u.access,
        actions: u.actions || [],
        admin: false,
        owner: false,
      }
      response.push(item)
    })
    return response;
  }

  public static fromFindCovidAssessmentPermissionsResponse(input: GetCovidAsPermissionResponse) {
    const response: DocumentPermissionData[] = [];
    input.users.forEach((u: CovidUserPermission) => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "USER",
        name: u.fullName,
        access: u.access,
        actions: u.actions || [],
        admin: false,
        owner: false,
      }
      response.push(item)
    })

    input.userGroups.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "GROUP",
        name: u.name,
        access: u.access,
        actions: u.actions || [],
        admin: false,
        owner: false,
      }
      response.push(item)
    })
    return response;
  }

  public static fromFindRiskAssessmentPermissionsResponse(input: GetGlobalMeasCheckPermissionResponse) {
    const response: DocumentPermissionData[] = [];
    input.users.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "USER",
        name: u.fullName,
        access: u.access,
        actions: u.actions || [],
        admin: false,
        owner: false,
      }
      response.push(item)
    })

    input.userGroups.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "GROUP",
        name: u.name,
        access: u.access,
        actions: u.actions || [],
        admin: false,
        owner: false,
      }
      response.push(item)
    })
    return response;
  }

  public static fromFindAppAssessmentPermissionsResponse(input: GetAppAsPermissionResponse) {
    const response: DocumentPermissionData[] = [];
    input.users.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "USER",
        name: u.fullName,
        access: u.access,
        actions: u.actions || [],
        admin: false,
        owner: false,
      }
      response.push(item)
    })

    input.userGroups.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "GROUP",
        name: u.name,
        access: u.access,
        actions: u.actions || [],
        admin: false,
        owner: false,
      }
      response.push(item)
    })
    return response;
  }

  public static fromFindAiAssessmentPermissionsResponse(input: GetAiAsPermissionResponse) {
    const response: DocumentPermissionData[] = [];
    input.users.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "USER",
        name: u.fullName,
        access: u.access,
        actions: u.actions || [],
        admin: false,
        owner: false,
      }
      response.push(item)
    })

    input.userGroups.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "GROUP",
        name: u.name,
        access: u.access,
        actions: u.actions || [],
        admin: false,
        owner: false,
      }
      response.push(item)
    })
    return response;
  }

  public static fromFindDataBreachPermissionsResponse(input: GetDataBreachPermissionResponse) {
    const response: DocumentPermissionData[] = [];
    input.users.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "USER",
        name: u.fullName,
        access: u.access,
        admin: false,
        owner: false,
        actions: u.actions || []
      }
      response.push(item)
    })

    input.userGroups.forEach(u => {
      const item: DocumentPermissionData = {
        id: u.id,
        type: "GROUP",
        name: u.name,
        access: u.access,
        admin: false,
        owner: false,
        actions: u.actions || []
      }
      response.push(item)
    })
    return response;
  }
}
